import React, { useMemo, useState } from "react";
import { RiSearchLine } from "react-icons/ri";
import FormGroup from "../../../theme/form-group/FormGroup";
import { useWorkflow } from "../../providers/WorkflowProvider";
import { WorkflowServiceAction } from "../../../../__generated__/api";
import ActionTag from "./ActionTag";
import Styles from "./ActionsTab.module.scss";
import NoResults from "../../../agent-v3/board/no-results/NoResults";

const DEFAULT_TAG = "Popular";

export default function ActionsTab() {
    const { services, servicesLoading, setServiceConfiguration } = useWorkflow();

    const [search, setSearch] = useState("");

    const tagsGroups = useMemo(
        () => services
            .filter(action => action.name
                .toLowerCase()
                .includes(search.toLowerCase()))
            .toSorted((action, actionB) => action.name.toLowerCase().localeCompare(actionB.name.toLowerCase()))
            .reduce((acc, action) => {
                const actionTags = action.tags ?? [];
                actionTags.forEach(tag => {
                    acc[tag] = [...(acc[tag] ?? []), action];
                });
                return acc;
            }, {} as Record<string, WorkflowServiceAction[]>),
        [search, services],
    );

    const tagList = useMemo(() => Object
        .entries(tagsGroups)
        .sortByDescending(([tag, tagServices]) => (tag === DEFAULT_TAG ? 100 : tagServices.length)), [tagsGroups]);

    if (servicesLoading) {
        return <div>Loading...</div>;
    }

    return (
        <>
            <FormGroup
                type="search"
                placeholder="Search..."
                prefixIcon={<RiSearchLine />}
                groupClassName={Styles["action-search-input"]}
                value={search}
                onChange={evt => setSearch(evt.target.value)}
                size="small"
            />
            {tagList.length === 0 && (
                <NoResults
                    title="Could not find any automation steps matching your search."
                />
            )}
            <div className={Styles["action-list"]}>
                {tagList.map(([tag, actions]) => (
                    <ActionTag
                        key={tag}
                        tag={tag}
                        actions={actions}
                        showServiceConfiguration={setServiceConfiguration}
                        isDefaultExpanded={search.length > 0}
                    />
                ))}
            </div>
        </>
    );
}
